export default "__VITE_ASSET__c0d7f4b3__"